import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
export const NotificationNode = memo(({ data, selected }) => {
    const nodeData = data;
    const metadata = nodeData.metadata;
    return (_jsxs("div", { className: `flow-node-notification ${selected ? "selected" : ""}`, style: {
            padding: "8px",
            border: `1px dashed ${selected ? "var(--flow-node-text, #000)" : "var(--flow-accent, #bdbdbd)"}`,
            borderRadius: "4px",
            background: "var(--flow-node-bg, #fff)",
            maxWidth: "180px",
            fontSize: "12px",
        }, children: [_jsx(Handle, { type: "target", position: Position.Top, style: { background: "var(--flow-accent, #bdbdbd)" } }), _jsxs("div", { children: [_jsx("div", { style: {
                            fontSize: "11px",
                            color: "var(--flow-node-text, #000)",
                            marginBottom: "4px",
                            lineHeight: "1.4",
                            wordBreak: "break-word",
                        }, children: metadata.message }), _jsxs("div", { style: {
                            fontSize: "10px",
                            color: "var(--flow-node-text-secondary, #444)",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                        }, children: [_jsx("span", { style: {
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    background: metadata.isRead ? "var(--flow-accent, #bdbdbd)" : "var(--flow-node-text, #000)",
                                    display: "inline-block",
                                } }), _jsx("span", { children: metadata.isRead ? "Read" : "Unread" })] })] }), _jsx(Handle, { type: "source", position: Position.Bottom, style: { background: "var(--flow-accent, #bdbdbd)" } })] }));
});
NotificationNode.displayName = "NotificationNode";
